import React from 'react';
import PropTypes from 'prop-types';

import DraftMessage from '../../correspondances/DraftMessage';

const TextResponseView = (props) => {
  const {isRegenerating, onDiscard, onRegenerate, response} = props;

  const [textData, setTextData] = React.useState(response.text);

  React.useEffect(() => {
    setTextData(response.text);
  }, [response]);

  const actions = [
    {
      key: 'regenerate',
      variant: 'secondary',
      expression: 'skills.SkillsModule.Text.Actions.Regenerate',
      disabled: isRegenerating,
      onClick: onRegenerate,
    },
    {
      key: 'discard',
      variant: 'tertiary',
      expression: 'skills.SkillsModule.Text.Actions.Discard',
      onClick: onDiscard,
    },
  ];

  return (
    <DraftMessage
      titleExpression='skills.SkillsModule.Text.Draft'
      bodyField={{
        value: textData,
        onChange: setTextData,
      }}
      actions={actions}
    />
  );
};

TextResponseView.propTypes = {
  isRegenerating: PropTypes.bool,
  onDiscard: PropTypes.func,
  onRegenerate: PropTypes.func,
  response: PropTypes.shape({
    text: PropTypes.string,
  }),
};

export default React.memo(TextResponseView);
